import { txt } from "@/content/ContentContext";
import { useSearchParams } from "react-router-dom";
import { Mail } from "lucide-react";
import { Header, Footer } from "@/pages/Landing";
import { ContactForm } from "@/components/ContactForm";
import { CONTACT_EMAIL } from "@/lib/plans";

export default function Contact() {
  const [sp] = useSearchParams();
  const type = sp.get("type") === "sales" ? "sales" : "support";
  return (
    <div className="min-h-[100dvh] bg-slate-50" data-testid="contact-page">
      <Header />
      <main className="mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:px-8 lg:grid-cols-[1fr_1.3fr]">
        <div>
          <div className="eyebrow">{txt("contact.contact")}</div>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">{txt("contact.talk_to_the_smart_in")}</h1>
          <p className="mt-4 max-w-md text-slate-600">{txt("contact.questions_about_your_counter_a")}</p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-slate-900 underline decoration-amber-500 underline-offset-4" data-testid="contact-page-email"><Mail className="h-4 w-4 text-amber-600" />{CONTACT_EMAIL}</a>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_20px_50px_-30px_rgba(15,23,42,0.45)] sm:p-7">
          <ContactForm key={type} initialType={type} />
        </div>
      </main>
      <Footer />
    </div>
  );
}
